"use client";

import { useEffect, useState, useRef } from "react";
import { useParams } from "next/navigation";
import { useAuth } from "@/context/AuthContext";
import Link from "next/link";
import { io, Socket } from "socket.io-client";
import BidModal from "@/components/BidModal";

type Auction = {
  id: number;
  title: string;
  type: string;
  location: string | null;
  start_at: string | null;
};

type Lot = {
  id: number;
  lot_number: string;
  title: string;
  status: string;
  current_price: number;
  increment: number;

  images?: string[];

  current_winner?: string | null;
  is_robot?: boolean;

  internet_dispute?: boolean;
  internet_deadline?: string | null;
};

export default function AuctionPage() {

  const { token, nickname } = useAuth();
  const params = useParams();
  const id = params.id as string;

  const [auction, setAuction] = useState<Auction | null>(null);
  const [lots, setLots] = useState<Lot[]>([]);
  const [modalLot, setModalLot] = useState<Lot | null>(null);

  const [highlightLots, setHighlightLots] = useState<number[]>([]);

  const socketRef = useRef<Socket | null>(null);

  const lotRefs = useRef<Record<number, HTMLDivElement | null>>({});

  const [serverOffset,setServerOffset] = useState(0)

  /* ================= colocar TIMER no catálogo ================= */
  const [now,setNow] = useState(Date.now())

        useEffect(()=>{
      const timer=setInterval(()=>{
        setNow(Date.now())
      },1000)

      return ()=>clearInterval(timer)

    },[])
  /* ================= fim - colocar TIMER no catálogo ================= */

  /* ================= CARREGAR AUCTION ================= */

  useEffect(() => {

    async function carregar() {

      const resAuction = await fetch(
        `https://api.nexbid.pro/auctions/${id}`
      );
      const auctionData = await resAuction.json();

      const resLots = await fetch(
        `https://api.nexbid.pro/auctions/${id}/lots`
      );
      const lotsData = await resLots.json();

      if (lotsData[0]?.server_now) {

        const serverTime = new Date(lotsData[0].server_now).getTime()
        const localTime = Date.now()

        setServerOffset(serverTime - localTime)

      }

      setAuction(auctionData);
      setLots(Array.isArray(lotsData) ? lotsData : []);

    }

    carregar();

  }, [id]);

  /* ================= SOCKET ================= */

useEffect(() => {

  socketRef.current = io("https://api.nexbid.pro", {
    transports: ["websocket"],
  });

  const socket = socketRef.current;

  /* ================= atualização de lote ================= */

  socket.on("lot:update", (data) => {

    if (!data || !data.lot_id) return;

    setLots((prev) =>
      prev.map((l) => {

        if (l.id !== data.lot_id) return l;

        return {
          ...l,

          status:
            data.status !== undefined
              ? data.status
              : l.status,

          current_price:
            data.current_price !== undefined
              ? data.current_price
              : l.current_price,

          current_winner:
            data.current_winner !== undefined
              ? data.current_winner
              : l.current_winner,

          is_robot:
            data.is_robot !== undefined
              ? data.is_robot
              : l.is_robot,

          internet_dispute:
            data.internet_dispute !== undefined
              ? data.internet_dispute
              : l.internet_dispute,

          internet_deadline:
            data.internet_deadline !== undefined
              ? data.internet_deadline
              : l.internet_deadline
        };

      })
    );

    /* animação de atualização */

    setHighlightLots((prev) => [...prev, data.lot_id]);

    setTimeout(() => {
      setHighlightLots((prev) =>
        prev.filter((id) => id !== data.lot_id)
      );
    }, 1200);

  });

  /* ================= auto scroll ================= */

  socket.on("lot:focus", (data) => {

    if (!data?.lot_id) return;

    const el = lotRefs.current[data.lot_id];

    if (!el) return;

    el.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });

  });

  /* ================= cleanup ================= */

  return () => {

    socket.off("lot:update");
    socket.off("lot:focus");

    socket.disconnect();

  };

}, []);
  

  /* ================= STATUS ================= */

  function traduzStatus(status: string) {

  if (status === "RECEBENDO_LANCES") return <div style={{ color:"#33353f", fontWeight:600 }}><center>🙋🏻‍♂️ Recebendo Lances</center></div>;

  if (status === "EM_LEILAO") return <div style={{ color:"#050381", fontWeight:600 }}><center>🪒 EM LEILÃO</center></div>;

  if (status === "DISPUTA_INTERNET") return <div style={{ color:"#dc2626", fontWeight:600 }}><center>⏱ Disputa Internet</center></div>;
  
  if (status === "DISPUTA_ENCERRADA") return <center><div style={{ color:"#2e0336", fontWeight:600 }}>🔚 Disputa Finalizada</div></center>;

  if (status === "VENDIDO") return "Vendido";

  if (status === "CONDICIONAL") return "Condicional";

  if (status === "RECUSADO") return "Venda Recusada";

  if (status === "RETIRADO") return "Retirado";

  return status;
}

  function traduzTipo(tipo: string) {

    if (tipo === "ONLINE") return "Somente On-line";
    if (tipo === "PRESENCIAL") return "Somente Presencial";
    if (tipo === "HIBRIDO") return "Presencial e On-line";

    return tipo;

  }

  if (!auction) return <div style={{ padding: 40 }}>Carregando...</div>;

  return (

    <div style={{ padding: 40, maxWidth: 1600, margin: "0 auto" }}>

      <h1>{auction.title}</h1>

      {auction.start_at && (
        <p>
          <strong>Data:</strong>{" "}
          {new Date(auction.start_at).toLocaleString()}
        </p>
      )}

      {auction.location && (
        <p>
          <strong>Local:</strong> {auction.location}
        </p>
      )}

      <p>
        <strong>Tipo:</strong> {traduzTipo(auction.type)}
      </p>

      {/* CABEÇALHO */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "80px 100px 1fr 160px 150px 160px",
          padding: "12px 0",
          fontWeight: 600,
          borderBottom: "2px solid #000",
        }}
      >
        <div>Lote</div>
        <div>Mídia</div>
        <div>Descrição</div>
        <div>Vencendo</div>
        <div>Status</div>
        <div>Valor Atual</div>
      </div>

      {lots.map((lot) => {

        const descricao =
          lot.title.length > 90
            ? lot.title.substring(0, 90) + "..."
            : lot.title;

        const thumb =
          lot.images && lot.images.length > 0
            ? lot.images[0]
            : null;
          /* ----------------------- */
          let tempoRestante = null

          if(lot.internet_deadline){

            const diff =
            new Date(lot.internet_deadline).getTime() - (now + serverOffset)

            tempoRestante = Math.max(0,Math.floor(diff/1000))

          }
          /* ----------------------- */

        const highlight = highlightLots.includes(lot.id);

        return (

          <div
              key={lot.id}
              ref={(el) => {
                lotRefs.current[lot.id] = el;
              }}
            style={{
              display: "grid",
              gridTemplateColumns: "80px 100px 1fr 160px 150px 160px",
              alignItems: "center",
              padding: "15px 0",
              borderBottom: "1px solid #ddd",
              background: highlight ? "rgba(22,163,74,0.12)" : "transparent",
              transition: "0.4s"
            }}
          >

            <div>
              <strong>{lot.lot_number}</strong>
            </div>

            <div>
              {thumb ? (
                <img
                  src={thumb}
                  style={{
                    width: 80,
                    height: 60,
                    objectFit: "cover",
                    borderRadius: 6,
                  }}
                />
              ) : (
                <span style={{ fontSize: 12 }}>Sem mídia</span>
              )}
            </div>

            <div>{descricao}</div>

            {/* VENCEDOR */}

            <div>

              {lot.current_winner && Number(lot.current_price) > 0 && (
             <div style={{ fontSize: 13 }}>
              {lot.is_robot && (
                <span style={{ marginRight: 4, opacity: 0.8 }}>🤖</span>
              )}
              {lot.current_winner || "—"}
            </div>
              )}

              {lot.current_winner && nickname && lot.current_winner === nickname && (
                <span
                  style={{
                    background: "#16a34a",
                    color: "#fff",
                    padding: "2px 6px",
                    fontSize: 11,
                    borderRadius: 4
                  }}
                >
                  VOCÊ ESTÁ VENCENDO
                </span>
              )}

            </div>

            <div>

            {lot.internet_dispute ? (
              <div style={{ color:"#dc2626", fontWeight:600 }}>
                ⏱ Disputa na Internet
              </div>
            ) : (
              traduzStatus(lot.status)
              )}

            {lot.internet_dispute && tempoRestante !== null && (
              <div style={{fontSize:12,color:"#dc2626"}}>

                ⏱ {Math.floor(tempoRestante/60)}:
                {(tempoRestante%60).toString().padStart(2,"0")}

              </div>
            )}

            </div>

            {/* VALOR */}

            <div>

              <strong
                style={{
                  color: highlight ? "#16a34a" : "#000",
                  fontSize: highlight ? 18 : 16,
                  transition: "0.3s"
                }}
              >

                {Number(lot.current_price) === 0
                  ? "😴😴😴"
                  : Number(lot.current_price).toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL"
                    })}

              </strong>

              <div>

                {token ? (
                  <button
                    onClick={() => setModalLot(lot)}
                    style={{
                      marginTop: 6,
                      padding: "6px 12px",
                      background: "#111827",
                      color: "#fff",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    Dar Lance
                  </button>
                ) : (
                  <Link href={`/login?redirect=/auction/${id}`}>
                    <button
                      style={{
                        marginTop: 6,
                        padding: "6px 12px",
                        background: "#111827",
                        color: "#fff",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      Entrar
                    </button>
                  </Link>
                )}

              </div>

            </div>

          </div>

        );

      })}

      {modalLot && (
        <BidModal
          lot={modalLot}
          onClose={() => setModalLot(null)}
        />
      )}

    </div>

  );

}